// extracted by mini-css-extract-plugin
export var infoBoxContainer = "bT_dz";
export var textContainer = "bT_cH";